import { BENCHMARK_BANNER_IMAGE, DisclosureImage, ESG_RATINGS_SCALE_IMAGE, EsgScoreImpactImages, IMAGE_10222, IMAGE_100833, IMAGE_578809, IMAGE_946534, IQFundIdeaIcons, IretirePnciImages, IretireSVGImages, ProposalSvgImages, RELATIVE_TO_BENCHMARK_BANNER_IMAGE, ScenarioAnalysisConstants, ScenarioTesterImages } from '@ddt-web/pdf-utils';

import { StaticContentSection } from './static-content-section';

export class SvgImage extends StaticContentSection {
	constructor(public name: string) {
		super();
	}

	public getStaticContent(): string {
		switch (this.name) {
			case 'ALLOCATION':
				return ProposalSvgImages.ALLOCATION;
			case 'PS_10Y_UP':
				return ScenarioTesterImages.PS_10Y_UP;
			case 'PS_CPI_UP':
				return ScenarioTesterImages.PS_CPI_UP;
			case 'PS_OIL_UP':
				return ScenarioTesterImages.PS_OIL_UP;
			case 'PS_SPX_DN':
				return ScenarioTesterImages.PS_SPX_DN;
			case 'PS_USIG_UP':
				return ScenarioTesterImages.PS_USIG_UP;
			case 'PS_VIX_UP':
				return ScenarioTesterImages.PS_VIX_UP;
			case 'FED13_ABS':
				return ScenarioTesterImages.FED13_ABS;
			case 'REC_ABS':
				return ScenarioTesterImages.REC_ABS;
			case 'CRASH08':
				return ScenarioTesterImages.CRASH08;
			case 'C07_ABS':
				return ScenarioTesterImages.C07_ABS;
			case 'COST':
				return ScenarioAnalysisConstants.SVG_ASSETS.COST;
			case 'PERFORMANCE':
				return ScenarioAnalysisConstants.SVG_ASSETS.PERFORMANCE;
			case 'RISK':
				return ScenarioAnalysisConstants.SVG_ASSETS.RISK;
			case 'DISCLOSURE':
				return DisclosureImage.DISCLOSURE;
			case 'ASSET_CLASS':
				return ScenarioTesterImages.ASSET_CLASS;
			case 'MODEL_PORTFOLIO':
				return ScenarioTesterImages.MODEL_PORTFOLIO;
			case 'CUSTOMIZED_MODEL_PORTFOLIO':
				return ScenarioTesterImages.CUSTOMIZED_MODEL_PORTFOLIO;
			case 'INTEREST':
				return ScenarioTesterImages.INTEREST;
			case 'BONDS':
				return ScenarioTesterImages.BONDS;
			case 'COMMODITIES':
				return ScenarioTesterImages.COMMODITIES;
			case 'EQUITIES':
				return ScenarioTesterImages.EQUITIES;
			case 'PAST':
				return ScenarioTesterImages.PAST;
			case 'ESG_RATINGS_SCALE':
				return ESG_RATINGS_SCALE_IMAGE;
			case 'BENCHMARK':
				return BENCHMARK_BANNER_IMAGE;
			case 'IMAGE_10222':
				return IMAGE_10222;
			case 'IMAGE_100833':
				return IMAGE_100833;
			case 'IMAGE_946534':
				return IMAGE_946534;
			case 'IMAGE_578809':
				return IMAGE_578809;
			case 'RELATIVE_TO_BENCHMARK':
				return RELATIVE_TO_BENCHMARK_BANNER_IMAGE;
			case 'FORESTS_CUT_PER_YEAR':
				return EsgScoreImpactImages.TREE;
			case 'PASSENGER_VEHICLES_DRIVEN':
				return EsgScoreImpactImages.CAR;
			case 'HOMES_ENERGY_PER_YEAR':
				return EsgScoreImpactImages.HOME;
			case 'POUNDS_COAL_BURNED':
				return EsgScoreImpactImages.COAL;
			case 'CONTROVERSIAL_WEAPONS':
				return EsgScoreImpactImages.WEAPON;
			case 'NUCLEAR_WEAPONS':
				return EsgScoreImpactImages.RADIATION;
			case 'CIVILIAN_FIREARMS':
				return EsgScoreImpactImages.WARNING;
			case 'TOBACCO':
				return EsgScoreImpactImages.TOBACCO;
			case 'THERMAL_COAL':
				return EsgScoreImpactImages.COAL;
			case 'LCD_TV':
				return EsgScoreImpactImages.LCD_TV;
			case 'REFRIGERATOR':
				return EsgScoreImpactImages.REFRIGERATOR;
			case 'CAR_TRANSPORTATION':
				return EsgScoreImpactImages.VEHICLE;
			case 'DISHWASHER':
				return EsgScoreImpactImages.FOOD;
			case 'WATER_HEATING':
				return EsgScoreImpactImages.WATER;
			case 'ARROW_RIGHT':
				return EsgScoreImpactImages.ARROW_RIGHT;
			case 'TARGET':
				return EsgScoreImpactImages.TARGET;
			case 'CARBON_EMISSION_DIFFERENCE':
				return EsgScoreImpactImages.PERCENTAGE;
			case 'PETROL_CONSUMED':
				return EsgScoreImpactImages.VEHICLE;
			case 'BARS_PROGRESS':
				return IretireSVGImages.BARS_PROGRESS;
			case 'PORTFOLIO':
				return IretireSVGImages.PORTFOLIO;
			case 'CONVERSATIONS':
				return IretireSVGImages.CONVERSATIONS;
			case 'EVENT_SCHEDULE':
				return IretireSVGImages.EVENT_SCHEDULE;
			case 'SAVINGS':
				return IretireSVGImages.SAVINGS;
			case 'FILE_PIN':
				return IretireSVGImages.FILE_PIN;
			case 'PIE_CHART':
				return IretireSVGImages.PIE_CHART;
			case 'ANNUITY_EMPTY_CHART':
				return IretireSVGImages.ANNUITY_EMPTY_CHART;
			case 'FUND_IDEA_GREEN':
				return IQFundIdeaIcons.FUND_IDEA_GREEN;
			case 'FUND_IDEA_YELLOW':
				return IQFundIdeaIcons.FUND_IDEA_YELLOW;
			case 'FUND_IDEA_RED':
				return IQFundIdeaIcons.FUND_IDEA_RED;
			case 'FUND_IDEA_GREEN_DISMISS':
				return IQFundIdeaIcons.FUND_IDEA_GREEN_DISMISS;
			case 'FUND_IDEA_YELLOW_DISMISS':
				return IQFundIdeaIcons.FUND_IDEA_YELLOW_DISMISS;
			case 'FUND_IDEA_RED_DISMISS':
				return IQFundIdeaIcons.FUND_IDEA_RED_DISMISS;
			case 'FUND_STATUS_DOWNGRADE_GREEN_TO_RED':
				return IQFundIdeaIcons.FUND_STATUS_DOWNGRADE_GREEN_TO_RED;
			case 'FUND_STATUS_DOWNGRADE_GREEN_TO_YELLOW':
				return IQFundIdeaIcons.FUND_STATUS_DOWNGRADE_GREEN_TO_YELLOW;
			case 'FUND_STATUS_DOWNGRADE_YELLOW_TO_RED':
				return IQFundIdeaIcons.FUND_STATUS_DOWNGRADE_YELLOW_TO_RED;
			case 'FUND_STATUS_UPGRADE_RED_TO_GREEN':
				return IQFundIdeaIcons.FUND_STATUS_UPGRADE_RED_TO_GREEN;
			case 'FUND_STATUS_UPGRADE_YELLOW_TO_GREEN':
				return IQFundIdeaIcons.FUND_STATUS_UPGRADE_YELLOW_TO_GREEN;
			case 'FUND_STATUS_UPGRADE_RED_TO_YELLOW':
				return IQFundIdeaIcons.FUND_STATUS_UPGRADE_RED_TO_YELLOW;
			case 'IRETIRE_PNCI_BARCODE_OTHER':
				return IretirePnciImages.PNCI_BARCODE_OTHER;
			case 'IRETIRE_PNCI_BARCODE_COVER':
				return IretirePnciImages.PNCI_BARCODE_COVER;
			case 'IRETIRE_PNCI_LOGO_OTHER':
				return IretirePnciImages.PNCI_LOGO_OTHER;
			case 'IRETIRE_PNCI_LOGO_COVER':
				return IretirePnciImages.PNCI_LOGO_COVER;
			case 'BAR_CHART':
				return IretireSVGImages.BAR_CHART;
		}
	}

	public getWidth(): number {
		return 150;
	}
	public getHeight(): number {
		return 150;
	}
}
